import { DEFAULT_ANALYTICS_FILTERING } from '@/utils/constants'
import createFiltersStore from '../createFiltersStore'

export const useDashboardUsageAndCostFiltersStore = createFiltersStore(
    'dashboardUsageAndCostFilters',
    DEFAULT_ANALYTICS_FILTERING
)
